import React from 'react';
import styles from "styles/pages/modal.module.scss";
import CustomButton from 'ui/CustomButton/CustomButton';


const NoificationModal=({
    label,
    title,
    content,
    image,
    backgroundColor="",
    color="",
    rejCallBack,
    affrCallBack,
    affrBtnTxt,
    rejBtnTxt,
    hideRejectBtn
}) =>{

   
 const affrBtnText= affrBtnTxt?affrBtnTxt:'Yes'
 const rejBtnText= rejBtnTxt?rejBtnTxt:'No'


    return (
        <>
                <div className={styles.modalMain} >
                    <div className={styles.modalHeader} style={{backgroundColor: backgroundColor}} >
                        <h4>{label}</h4>
                    </div>
                    <div className={styles.modalBody}>
                        <div className={styles.modal_cont}>
                            <div className={styles.modal_cont_left}>
                                <img src={image} alt="img" />
                            </div>
                            <div className={styles.modal_cont_right}>
                                <h2 dangerouslySetInnerHTML={{__html: title}}>
                                    {/* {title} */}
                                </h2>
                                <p  dangerouslySetInnerHTML={{__html: content}}>

                                    {/* {content} */}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.modalButton}>
                        <CustomButton onClick={affrCallBack}>{affrBtnText}</CustomButton>
                       {!hideRejectBtn && <CustomButton style={{color: color}}
                    //    style={{backgroundColor: backgroundColor}}
                       onClick={rejCallBack}>{rejBtnText}</CustomButton>}
                    </div>
                </div>

        </>
    );
}
export default  React.memo(NoificationModal);